import React, { FC, ReactNode } from 'react';
import clsx from 'clsx';

type Props = {
  children: ReactNode;
  variant?: 'default' | 'annotation';
  isDone?: boolean;
};

const CommentsListItemReplyBubbleWrapper: FC<Props> = ({
  children,
  variant = 'default',
  isDone = false,
}) => {
  return (
    <div
      className={clsx(
        'tw-max-w-[496px] tw-flex-grow-0 tw-gap-2 tw-rounded-xl tw-border tw-px-4 tw-py-[6px] tw-pb-6 tw-text-xs tw-font-regular tw-text-grayscale-180 tw-transition-colors tw-duration-200',
        {
          'tw-border-grayscale-10': variant === 'default',
          'tw-border-orange-50 tw-bg-orange-10':
            variant === 'annotation' && !isDone,
          'tw-border-success-30 tw-bg-success-10':
            variant === 'annotation' && isDone,
        },
      )}
    >
      {children}
    </div>
  );
};

export default CommentsListItemReplyBubbleWrapper;
